const DeleteIcon = () => (
  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.25 4.75H23.75M4.75 9.5H33.25M30.0833 9.5L28.973 26.1555C28.8064 28.6544 28.7231 29.9039 28.1834 30.8513C27.7082 31.6853 26.9915 32.3559 26.1276 32.7745C25.1465 33.25 23.8942 33.25 21.3898 33.25H16.6102C14.1058 33.25 12.8535 33.25 11.8724 32.7745C11.0085 32.3559 10.2918 31.6853 9.81664 30.8513C9.27693 29.9039 9.19363 28.6544 9.02704 26.1555L7.91667 9.5M15.8333 16.625V24.5417M22.1667 16.625V24.5417"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DeleteIcon;
